import { useFetchDeliveryNotes } from './useFetchDeliveryNotes'

export const useHasDeliveryNotes = (): boolean => {
  const { deliveryNotes, isError, isLoading } = useFetchDeliveryNotes()

  return isLoading || isError || deliveryNotes.length > 0
}
